import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import BajaMultiple from "../../BajaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";


import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";

function ListadoCotizaciones() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_COTIZACIONES = process.env.REACT_APP_URL_COTIZACIONES;
  const URL_ARTICULOS_COTIZACION = process.env.REACT_APP_URL_ARTICULOS_COTIZACION;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_EXPLOSION = process.env.REACT_APP_URL_EXPLOSION;
  const URL_EXPLOSION_GLOBAL = process.env.REACT_APP_URL_EXPLOSION_GLOBAL;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_CATALOGO_PROCESOS = process.env.REACT_APP_URL_CATALOGO_PROCESOS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_COMPRADORES = process.env.REACT_APP_URL_COMPRADORES;
  const URL_AREAS_CLIENTES = process.env.REACT_APP_URL_AREAS_CLIENTES;
  // const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 90);

  let valida = new Date();
  valida.setDate(valida.getDate() + 8);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");
  let validador = moment(valida).format("YYYY-MM-DD");
  const ordenTallas = ["2XCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","ESP","VARIOS","2","4","6","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56"];
  const [cotizaciones, setCotizaciones] = useState([]);

  const [articulos, setArticulos] = useState([]);
  const [subDepartamentosCat, setSubDepartamentosCat] = useState([]);
  const [departamentosCat, setDepartamentosCat] = useState([]);
  const [areasClientes, setAreasClientes] = useState([]);
const [areasClientesOptions, setAreasClientesOptions] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [compradores, setCompradores] = useState([]);
  const [selectedComprador, setSelectedComprador] = useState("");
  // const [marcas, setMarcas] = useState([]);
  // const [selectedMarca, setSelectedMarca] = useState("");

  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [telas, setTelas] = useState([]);
  const [habilitacion, setHabilitacion] = useState([]);

  const [selectedArticulo, setSelectedArticulo] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [fecha, setFecha] = useState("");
  const [fecha_cancelacion, setFechaCancelacion] = useState("");
  const [fecha_confirmacion, setFechaConfirmacion] = useState("");
  // const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState("");
  const [total_kilos, setTotalUnidaKilos] = useState("");
  const [total_metros, setTotalUnidaMetros] = useState("");
  const [numero_cotizacion, setNumeroCotizacion] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [selectedClienteEdit, setSelectedClienteEdit] = useState("");
  const [selectedEmpresaEdit, setSelectedEmpresaEdit] = useState("");
  const [selectedCompradorEdit, setSelectedCompradorEdit] = useState("");
  const [selectedColaboradorEdit, setSelectedColaboradorEdit] = useState("");
  const [idArticuloEdit, setIdArticuloEdit] = useState("");
  const [cotizacionCliente, setCotizacionCliente] = useState("");

  const [articulosCotizacion, setArticulosCotizacion] = useState([]);
  const [idArticuloCotizacion, setIdArticuloCotizacion] = useState("");
  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [total_general_edit, setTotalGeneralEdit] = useState(0);
  // T5 (2026-06) — descuento general editable
  const [descuento_edit, setDescuentoEdit] = useState(0);
  const [total_kilos_edit, setTotalKilosEdit] = useState(0);
  const [total_metros_edit, setTotalMetrosEdit] = useState(0);
  const [total_cantidad_edit, setTotalCantidadEdit] = useState(0);

  const [codigo, setCodigo] = useState("");
  const [descripcion, setDescripcion] = useState("");

  const [colores, setColores] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");
  const [tallas, setTallas] = useState([]);
  const [selectedTalla, setSelectedTalla] = useState("");
  const [catalogoProcesos, setCatalogoProcesos] = useState([]);

  const [modalExplosion, setModalExplosion] = useState(false);
  const toggleExplosion = () => setModalExplosion(!modalExplosion);
  const [explosionExistentes, setExplosionExistentes] = useState([]);
  const [codigoExplosion, setCodigoExplosion] = useState("");
  const [idExplosion, setIdExplosion] = useState("");
  const [descripcionExplosion, setDescripcionExplosion] = useState("");

  const [modalExplosionGlobal, setModalExplosionGlobal] = useState(false);
  const toggleExplosionGlobal = () =>
    setModalExplosionGlobal(!modalExplosionGlobal);
  const [explosionGlobalExistente, setExplosionGlobalExistente] = useState([]);

  const [idColoresArticulos, setIdColoresArticulos] = useState("");
  const [modalColores, setModalColores] = useState(false);
  const toggleColores = () => setModalColores(!modalColores);
  const [arrayColores, setArrayColores] = useState([]);

  const [idTallasArticulos, setIdTallasArticulos] = useState("");
  const [modalTallas, setModalTallas] = useState(false);
  const toggleTallas = () => setModalTallas(!modalTallas);
  const [arrayTallas, setArrayTallas] = useState([]);

  const [idCatalogoProcesosArticulos, setIdCatalogoProcesosArticulos] =
    useState("");
  const [modalCatalogoProcesos, setModalCatalogoProcesos] = useState(false);
  const toggleCatalogoProcesos = () =>
    setModalCatalogoProcesos(!modalCatalogoProcesos);
  const [arrayCatalogoProcesos, setArrayCatalogoProcesos] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);

  const [idEditArticuloEdit, setIdEditArticuloEdit] = useState("");
  const [codigoEdit, setCodigoEdit] = useState("");
  const [codigoClienteEdit, setCodigoClienteEdit] = useState("");
  const [nombreEdit, setNombreEdit] = useState("");
  const [descripcionEdit, setDescripcionEdit] = useState("");
  const [precioEtiquetaEdit, setPrecioEtiquetaEdit] = useState("");
  const [ventaEdit, setVentaEdit] = useState("");
  const [observacionesEdit, setObservacionesEdit] = useState("");
  const [condicionesEdit, setCondicionesEdit] = useState("");
  const [nombreFirmaEdit, setNombreFirmaEdit] = useState("");
  const [puestoFirmaEdit, setPuestoFirmaEdit] = useState("");
  const [nombreCompradorEdit, setNombreCompradorEdit] = useState("");
  const [puestoCompradorEdit, setPuestoCompradorEdit] = useState("");
  const [cantidadColaboradoresEdit, setCantidadColaboradoresEdit] = useState(0);
  const [observacionesProduccionEdit, setObservacionesProduccionEdit] =
    useState("");
  // const [selectedMarcaEdit, setSelectedMarcaEdit] = useState("");
  const [modalEditInfoArticulo, setModalEditInfoArticulo] = useState(false);
  const toggleEditInfoArticulo = () =>
    setModalEditInfoArticulo(!modalEditInfoArticulo);
  const [selectedPendFechaConf, setSelectedPendFechaConf] = useState("");

  const [modalPrecosteo, setModalPrecosteo] = useState(false);
  const togglePrecosteo = () => setModalPrecosteo(!modalPrecosteo);
  const [precosteoTelas, setPrecosteoTelas] = useState([]);
  const [precosteoHab, setPrecosteoHab] = useState([]);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      resurtido: "",
      unidad: 0,
      colores: "",
      arrayColoresArticulo: [],
      tallas: "",
      arrayTallasArticulo: [],
      cantidad: 0,
      surtido: 0,
      precio: 0,
      precioEtiqueta: 0,
      descuento: 0,
      total: 0,
      codigoBarras: 0,
    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [activo, setActivo] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("Abierto");

  const [modalStatus, setModalStatus] = useState(false);
  const toggleStatus = () => setModalStatus(!modalStatus);

  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;

  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  // L93 (2026-06) — al venir de guardar una cotización (CotizacionesCreate setea
  // localStorage.autoPDFCotizacion), abrir su PDFOC en automático cuando carguen
  // los datos. PDFOC está hoisteada (function declaration) → disponible aquí.
  useEffect(() => {
    const autoPDFId = localStorage.getItem("autoPDFCotizacion");
    if (!autoPDFId || !comments || comments.length === 0) return;
    const cot = comments.find((c) => String(c._id) === String(autoPDFId));
    if (cot) {
      localStorage.removeItem("autoPDFCotizacion");
      try {
        PDFOC(
          cot.fecha,
          cot.clientes,
          cot.condiciones,
          cot.nombreFirma,
          cot.puestoFirma,
          cot.nombreComprador,
          cot.puestoComprador,
          cot.cantidadColaboradores,
          cot.numero,
          cot._id,
          cot.calle,
          cot.colonia,
          cot.ciudad,
          cot.telefono,
          cot.email,
          cot.descuento,
          cot.empresas // L105
        );
      } catch (e) {
        console.warn("No se pudo abrir el PDF automático:", e);
      }
    }
  }, [comments]);

  useMemo(() => {
    axios
      .get(`${URL_COTIZACIONES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
.then((response) => {
  // === Helpers de saneo y composición ===
  const s = (v) => {
    if (v === null || v === undefined) return "";
    const raw = String(v).trim();
    const up = raw.replace(/\s+/g, " ").replace(/[.\s/]/g, "").toUpperCase();
    const empties = new Set(["", "NA", "N/A", "N.A", "NULL", "UNDEFINED", "-", "--", "SN", "S/N", "S.N", "0"]);
    return empties.has(up) ? "" : raw;
  };
  const clean = (...parts) => parts.map(s).filter(Boolean);
  const joinWith = (parts, sep) => clean(...parts).join(sep);

  // Calle compuesta: calle + num ext + num int (si existen)
  const composeStreet = (cli) => {
    if (!cli) return "";
    const { calle, numero_ext, numero_int, numero, no, ext, exterior, interior, referencia } = cli;
    const numExt = numero_ext || numero || no || ext || exterior;
    const numInt = numero_int || interior ? `${numero_int || interior}` : "";
    return joinWith([calle, numExt, numInt, referencia], " ");
  };

  // Colonia compuesta: colonia + municipio/alcaldía + ciudad + estado + CP (si existen)
  const composeColonia = (cli) => {
    if (!cli) return "";
    const { colonia, municipio, alcaldia, ciudad, estado, cp, zipcode, cpostal } = cli;
    const cpFinal = cp || zipcode || cpostal;
    return joinWith([colonia, municipio || alcaldia || ciudad, estado, cpFinal], ", ");
  };

  let allCotizaciones = response.data;

  // Array para pagination
  let arrayTabla = (allCotizaciones || [])
    .sort(
      (a, b) => (Number(b?.idCotizacion) || 0) - (Number(a?.idCotizacion) || 0)
    )
    .map((a) => {
      const cli = a?.clientes?.[0] || {};
      const colab = a?.colaboradores?.[0] || {};
      const emp = a?.empresas?.[0] || {};
      // (2026-10) cotización a un prospecto del CRM (todavía sin cliente)
      const pro = !cli?._id ? a?.crmProspectos?.[0] : null;

      return {
        _id: a?._id,
        numero: s(a?.idCotizacion),
        activo: s(a?.is_active),
        fecha: s(a?.fecha),

        // Cliente y domicilio (sanitizados y compuestos)
        clientes: pro
          ? `${s(pro.empresa) || s(pro.razon_social)} (Prospecto)`
          : s(cli?.nombre_comercial),
        calle: pro ? "" : composeStreet(cli),
        colonia: pro ? s(pro.estado) : composeColonia(cli),

        telefono: s(pro ? pro.telefono : cli?.telefono),
        email: s(pro ? pro.email : cli?.email),

        idClientes: s(cli?._id),
        esProspecto: !!pro,

        // Colaborador
        colaboradores: joinWith([colab?.nombre, colab?.apellido], " "),
        idColaboradores: s(colab?._id),

        // Empresa
        empresas: s(emp?.name),
        idEmpresas: s(emp?._id),

        condiciones: s(a?.condiciones),
        observaciones: s(a?.observaciones),
        subTotal: Number(a?.subTotal || 0),
        descuento: Number(a?.descuento || 0),
        total_general: Number(a?.total_general || 0),
        cantidad: Number(a?.total_piezas || 0),
        status: s(a?.status),

        nombreFirma: s(a?.nombreFirma),
        puestoFirma: s(a?.puestoFirma),
        nombreComprador: s(a?.nombreComprador),
        puestoComprador: s(a?.puestoComprador),
        cantidadColaboradores: Number(a?.cantidadColaboradores || 0),

        // (2026-09) Autorización de la cotización
        autorizacion: s(a?.autorizacion) || "No",
        autorizacionUser: joinWith(
          [a?.autorizacionUser?.nombre, a?.autorizacionUser?.apellido],
          " "
        ),
        autorizacionFecha: s(a?.autorizacionFecha),
      };
    })
    .filter(Boolean);

  const data = Object.values(arrayTabla);
  setCotizaciones(data);
  setComments(data);
})

      .catch((err) => {
        console.log(err);
      });


    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEmpresas = response.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      });
 axios
      .get(URL_AREAS_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAreasClientes = response.data;
        setAreasClientes(allAreasClientes);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COMPRADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCompradores = response.data;
        setCompradores(allCompradores);
      })
      .catch((err) => {
        console.log(err);
      });

    // axios
    // .get(URL_MARCAS, {
    //   headers: {
    //     Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //   },
    // })
    // .then((response) => {
    //   let allMarcas = response.data;
    //   setMarcas(allMarcas);
    // })
    // .catch((err) => {
    //   console.log(err);
    // });

    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(process.env.REACT_APP_URL_SUBDEPARTAMENTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setSubDepartamentosCat(response.data || []);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(process.env.REACT_APP_URL_DEPARTAMENTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setDepartamentosCat(response.data || []);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TELAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTelas = res.data;
        setTelas(allTelas);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_HABILITACION, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allHabilitacion = res.data;
        setHabilitacion(allHabilitacion);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColores = response.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allTallas = response.data;
        setTallas(allTallas);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CATALOGO_PROCESOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCatalogoProcesos = response.data;
        setCatalogoProcesos(allCatalogoProcesos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  const ListaCotizaciones = [...comments].sort(
    (a, b) => (Number(b?.idCotizacion) || 0) - (Number(a?.idCotizacion) || 0)
  );

  function PDFTabla() {
    const data = ListaCotizaciones.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [
          a.activo,
          a.numero,
          a.fecha,
          a.colaboradores,
          a.articulo,
          a.fecha_cancelacion,
          a.fecha_confirmacion,
          a.clientes,
          a.total_kilos,
          a.total_metros,
          "$" + new Intl.NumberFormat("en-US").format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Cotizaciones`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Activo",
          "Numero",
          "Fecha",
          "Vendedor",
          "Articulo",
          "Fecha Cancelacion",
          "Fecha Confirmacion",
          "Cliente",
          "Kilos",
          "Metros",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    // doc.save(`Cotizaciones.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = ListaCotizaciones.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return {
          Activo: a.activo,
          Numero: a.numero,
          Fecha: a.fecha,
          Vendedor: a.colaboradores,
          Articulo: a.articulos,
          Cancelacion: a.fecha_cancelacion,
          Confirmacion: a.fecha_confirmacion,
          Cliente: a.clientes,
          Kilos: a.total_kilos,
          Metros: a.total_metros,
          Total: a.total_general,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoCotizaciones";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoCotizaciones",
        sheetFilter: [
          "Activo",
          "Numero",
          "Fecha",
          "Vendedor",
          "Articulo",
          "Cancelacion",
          "Confirmacion",
          "Cliente",
          "Kilos",
          "Metros",
          "Total",
        ],
        sheetHeader: [
          "Activo",
          "Numero",
          "Fecha",
          "Vendedor",
          "Articulo",
          "Cancelacion",
          "Confirmacion",
          "Cliente",
          "Kilos",
          "Metros",
          "Total",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = ListaCotizaciones.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [
          a.activo,
          a.numero,
          a.fecha,
          a.colaboradores,
          a.articulos,
          a.fecha_cancelacion,
          a.fecha_confirmacion,
          a.clientes,
          a.total_kilos,
          a.total_metros,
          "$" + new Intl.NumberFormat("en-US").format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Ordenes de Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Activo",
          "Numero",
          "Fecha",
          "Vendedor",
          "Articulo",
          "Fecha Cancelacion",
          "Fecha Confirmacion",
          "Cliente",
          "Kilos",
          "Metros",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    // L91 (2026-06) — generar base64 con el propio jsPDF (evita "Buffer is not
    // defined": nodejs-base64-encode usa Buffer de Node, ausente en el browser)
    var base64File = doc.output("datauristring").split(",")[1];

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Cotizaciones",
          email: mailTo,
          fileName: "ListadoCotizaciones.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Cotizaciones.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          // window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    fecha,
    idColaboradores,
    idClientes,
    idEmpresas,
    idComprador,
    observaciones,
    condiciones,
    nombreFirma,
    puestoFirma,
    nombreComprador,
    puestoComprador,
    cantidadColaboradores,
    numero_cotizacion,
    idEdit,
    cotizacionCliente
  ) {
    setFecha(fecha);
    setSelectedColaboradorEdit(idColaboradores);
    setSelectedClienteEdit(idClientes);
    setSelectedEmpresaEdit(idEmpresas);
    setSelectedCompradorEdit(idComprador);
    setObservacionesEdit(observaciones);
    setCondicionesEdit(condiciones);
    setNombreFirmaEdit(nombreFirma);
    setPuestoFirmaEdit(puestoFirma);
    setNombreCompradorEdit(nombreComprador);
    setPuestoCompradorEdit(puestoComprador);
    setCantidadColaboradoresEdit(cantidadColaboradores);
    setNumeroCotizacion(numero_cotizacion);
    setIdEdit(idEdit);
    setCotizacionCliente(cotizacionCliente);
    toggleEdit();
  }

// L105 (2026-06) — usar logoInstitucionDonnatela cuando la empresa es UNIFORMES INNOVACIÓN
function logoInstSrc(empresa) {
  const t =
    typeof empresa === "string"
      ? empresa
      : empresa?.razonSocial || empresa?.name || "";
  const norm = t
    .normalize("NFD")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .toLowerCase();
  const file = norm.includes("uniformes innovacion")
    ? "logoInstitucionDonnatela.png"
    : "logoInstitucion.png";
  return process.env.PUBLIC_URL + file;
}
async function PDFOC(
  fecha,
  clientes,
  condiciones,
  nombreFirma,
  puestoFirma,
  nombreComprador,
  puestoComprador,
  cantidadColaboradores,
  numero,
  idPDFOC,
  calle,
  colonia,
  ciudad,
  telefono,
  email,
  descuento = 0,
  // L105 (2026-06) — nombre de empresa para elegir el logo
  empresa = ""
) {
  // === Helpers ===
  const s = (v) => {
    if (v === null || v === undefined) return "";
    const raw = String(v).trim();
    const up = raw.replace(/\s+/g, " ").replace(/[.\s/]/g, "").toUpperCase();
    const empties = new Set([
      "",
      "NA",
      "N/A",
      "N.A",
      "NULL",
      "UNDEFINED",
      "-",
      "--",
      "SN",
      "S/N",
      "S.N",
    ]);
    return empties.has(up) ? "" : raw;
  };

  const sn = (v, def = 0) => {
    if (v === null || v === undefined) return def;
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return def;
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  const cleanParts = (...parts) => parts.map(s).filter(Boolean);
  const joinWith = (parts, sep = " ") => cleanParts(...parts).join(sep);

  const composeStreet = (calle) => {
    if (Array.isArray(calle)) return joinWith(calle, " ");
    if (calle && typeof calle === "object") {
      const { calle: via, numero, no, ext, exterior, interior, referencia } =
        calle;
      return joinWith(
        [
          via,
          numero || no || ext || exterior,
          interior ? `Int. ${interior}` : "",
          referencia,
        ],
        " "
      );
    }
    return s(calle);
  };

  const composeColonia = (colonia, ciudad) => {
    if (Array.isArray(colonia)) return joinWith(colonia, ", ");
    if (colonia && typeof colonia === "object") {
      const {
        colonia: col,
        barrio,
        fracc,
        municipio,
        alcaldia,
        ciudad: c2,
        estado,
        cp,
        zipcode,
        cpostal,
      } = colonia;

      return joinWith(
        [
          col || barrio || fracc,
          municipio || alcaldia,
          c2 || ciudad,
          estado,
          cp || zipcode || cpostal,
        ],
        ", "
      );
    }
    return joinWith([colonia, ciudad], ", ");
  };

  try {
    const { data: allArticulosCotizacion } = await axios.get(
      `${URL_ARTICULOS_COTIZACION}/cotizaciones/${idPDFOC}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const colaboradores = Math.max(1, Math.trunc(sn(cantidadColaboradores, 1)));
    const descuentoPorcentaje = sn(descuento, 0);

    // L116 (2026-06) — imprimir los artículos en el orden en que se capturaron.
    // Se ordena por el consecutivo `orden` (BD): los que tienen orden>0 van primero
    // por ese número; los antiguos o agregados en edición (orden 0/ausente) quedan
    // al final conservando su orden natural (sort estable). Así las áreas, deptos y
    // renglones siguen la secuencia de alta.
    const ordKey = (a) => {
      const n = Number(a?.orden);
      return Number.isFinite(n) && n > 0 ? n : Infinity;
    };
    const articulosOrdenados = [...allArticulosCotizacion].sort(
      (a, b) => ordKey(a) - ordKey(b)
    );

    const agrupado = {};

    articulosOrdenados.forEach((a) => {
      const area = s(a.areasClientes?.[0]?.name) || "Sin Área";
      const departamento = s(a.departamentos?.[0]?.name) || "Sin Departamento";

      if (!agrupado[area]) agrupado[area] = {};
      if (!agrupado[area][departamento]) agrupado[area][departamento] = [];

      agrupado[area][departamento].push(a);
    });

    // L48 (2026-06) — formato corporativo (portrait)
    const fmtMoney = (n) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(sn(n, 0));

    const fmtInt = (n) =>
      new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 0,
      }).format(sn(n, 0));

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 14;
    const marginRight = 14;
    const marginBottom = 12;

    // L114 (2026-06) — morado si la empresa es UNIFORMES INNOVACIÓN (logo Donnatela)
    const brandColor = /Donnatela/i.test(logoInstSrc(empresa))
      ? [205, 184, 245]
      : [42, 90, 138];
    const lightBg = [245, 247, 250];
    const borderColor = [210, 216, 224];
    const labelColor = [110, 120, 135];
    const stripeBg = [251, 252, 253];

    const drawLabel = (label, value, lblX, valX, y) => {
      doc.setFont(undefined, "bold");
      doc.setTextColor(...labelColor);
      doc.setFontSize(8);
      doc.text(label, lblX, y);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9);
      const txt = String(value ?? "").trim();
      doc.text(txt || "—", valX, y);
    };

    // ============ LOGO IZQ + TÍTULO DER + LÍNEA AZUL ============
    const img2 = new Image();
    img2.src = logoInstSrc(empresa); // L105
    await new Promise((resolve) => {
      img2.onload = () => {
        const maxH = /Donnatela/i.test(img2.src) ? 22 : 14; // L115 logo Donnatela más grande
        const scale = maxH / img2.height;
        doc.addImage(img2, "png", marginLeft, 8, img2.width * scale, maxH);
        resolve();
      };
      img2.onerror = () => resolve();
    });

    doc.setFont(undefined, "bold");
    doc.setFontSize(14);
    doc.setTextColor(...brandColor);
    doc.text(`COTIZACIÓN # ${s(numero)}`, pageWidth - marginRight, 16, { align: "right" });
    // TF3 — Fecha debajo del título (se quitó de la columna derecha para no encimar la Calle)
    doc.setFont(undefined, "normal");
    doc.setFontSize(9.5);
    doc.setTextColor(...labelColor);
    doc.text(`Fecha: ${s(fecha)}`, pageWidth - marginRight, 21, { align: "right" });
    doc.setTextColor(0);

    doc.setDrawColor(...brandColor);
    doc.setLineWidth(0.5);
    doc.line(marginLeft, 25, pageWidth - marginRight, 25);
    doc.setLineWidth(0.2);
    doc.setDrawColor(0);

    // ============ CARD CON DATOS — 2 COLUMNAS ============
    const cardY = 28;
    const cardW = pageWidth - marginLeft - marginRight;
    const cardH = 36;
    doc.setDrawColor(...borderColor);
    doc.setFillColor(...lightBg);
    doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
    doc.setDrawColor(0);

    const lblX_L = marginLeft + 2;
    const valX_L = marginLeft + 24;
    const baseY = cardY + 5;
    drawLabel("Cliente:", s(clientes), lblX_L, valX_L, baseY);
    drawLabel("Calle:", composeStreet(calle), lblX_L, valX_L, baseY + 4.5);
    drawLabel("Col.:", composeColonia(colonia, ciudad), lblX_L, valX_L, baseY + 9);
    drawLabel("Tel:", s(telefono), lblX_L, valX_L, baseY + 13.5);
    drawLabel("Email:", s(email), lblX_L, valX_L, baseY + 18);
    drawLabel("Comprador:", s(nombreComprador), lblX_L, valX_L, baseY + 22.5);
    drawLabel("Depto:", s(puestoComprador), lblX_L, valX_L, baseY + 27);

    const colRightX = pageWidth / 2 + 5;
    const lblX_R = colRightX;
    const valX_R = colRightX + 26;
    // TF3 — La Fecha se movió debajo del título y la Cotización # ya está en el título,
    // para que la Calle (que puede ser larga) no se encime con la columna derecha.
    if (colaboradores > 1) {
      drawLabel("Colaboradores:", colaboradores, lblX_R, valX_R, baseY);
    }

    let currentY = cardY + cardH + 5;

    let totalPiezasGlobal = 0;
    let subtotalGlobal = 0;

    // ============ RECORRER ÁREAS + DEPTOS ============
    for (const areaNombre of Object.keys(agrupado)) {
      if (currentY > pageHeight - 30) {
        doc.addPage();
        currentY = 20;
      }

      // Banda azul ÁREA
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, cardW, 7, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10.5);
      doc.text(`ÁREA: ${s(areaNombre) || "Sin Área"}`, marginLeft + 3, currentY + 5);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      currentY += 9;

      const departamentosDeArea = agrupado[areaNombre];

      for (const deptNombre of Object.keys(departamentosDeArea)) {
        const grupo = departamentosDeArea[deptNombre];

        if (currentY > pageHeight - 30) {
          doc.addPage();
          currentY = 20;
        }

        // Sub-banda DEPTO
        doc.setFillColor(225, 232, 240);
        doc.rect(marginLeft, currentY, cardW, 6, "F");
        doc.setTextColor(...brandColor);
        doc.setFont(undefined, "bold");
        doc.setFontSize(9.5);
        doc.text(`Departamento: ${s(deptNombre) || "Sin Departamento"}`, marginLeft + 3, currentY + 4.2);
        doc.setTextColor(0);
        doc.setFont(undefined, "normal");
        currentY += 8;

        const bodyData = [];

        grupo.forEach((item) => {
          const articulo = s(item.subDepartamentos?.[0]?.name) || "Sin Artículo";
          const tela = s(item.tela);
          const precio = sn(item.precio, 0);
          const cantidad = sn(item.cantidad, 0);
          const total = +(precio * cantidad).toFixed(2);
          const obsArticulo = (() => {
            const raw = String(item.observacionesArticulo ?? "").trim();
            return raw && raw.toUpperCase() !== "NA" ? raw : "";
          })();

          totalPiezasGlobal += cantidad;
          subtotalGlobal += total;

          bodyData.push([
            articulo,
            tela,
            fmtInt(cantidad),
            fmtMoney(precio),
            fmtMoney(total),
            obsArticulo,
          ]);
        });

        doc.autoTable({
          head: [["Artículo", "Tela", "Cantidad", "Precio Unitario", "Total", "Observaciones"]],
          body: bodyData,
          startY: currentY,
          margin: { left: marginLeft, right: marginRight },
          theme: "grid",
          styles: {
            fontSize: 9,
            cellPadding: 1.2,
            valign: "middle",
            halign: "center",
            overflow: "linebreak",
            lineColor: borderColor,
            lineWidth: 0.15,
          },
          headStyles: {
            fillColor: brandColor,
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 9.5,
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: stripeBg,
          },
          columnStyles: {
            5: { halign: "left", cellWidth: 40 },
          },
        });

        currentY = doc.autoTable.previous.finalY + 6;
      }
    }

    // === Totales con descuento ===
    const descuentoDinero = +(
      subtotalGlobal *
      (descuentoPorcentaje / 100)
    ).toFixed(2);

    const baseIVA = +(subtotalGlobal - descuentoDinero).toFixed(2);
    const ivaGlobal = +(baseIVA * 0.16).toFixed(2);
    const totalConIva = +(baseIVA + ivaGlobal).toFixed(2);

    if (currentY + 50 > pageHeight - marginBottom) {
      doc.addPage();
      currentY = 20;
    }

    // ============ RESUMEN GENERAL — mini-tabla bordada a la derecha ============
    doc.setFont(undefined, "bold");
    doc.setFontSize(11);
    doc.setTextColor(...brandColor);
    doc.text("RESUMEN GENERAL", pageWidth - marginRight, currentY, { align: "right" });
    doc.setTextColor(0);
    currentY += 3;

    const bodyTotales = [
      ["Total de piezas", fmtInt(totalPiezasGlobal)],
      ["Subtotal", fmtMoney(subtotalGlobal)],
    ];

    if (descuentoPorcentaje > 0) {
      bodyTotales.push([
        `Descuento (${descuentoPorcentaje}%)`,
        `- ${fmtMoney(descuentoDinero)}`,
      ]);
      bodyTotales.push(["Subtotal con descuento", fmtMoney(baseIVA)]);
    }

    bodyTotales.push(["IVA (16%)", fmtMoney(ivaGlobal)]);
    bodyTotales.push(["Total con IVA", fmtMoney(totalConIva)]);

    const resumenW = 90;
    const resumenLabelW = 50;
    const resumenX = pageWidth - marginRight - resumenW;

    doc.autoTable({
      startY: currentY,
      margin: { left: resumenX, right: marginRight },
      tableWidth: resumenW,
      body: bodyTotales,
      theme: "grid",
      styles: {
        fontSize: 9.5,
        cellPadding: 1.4,
        lineColor: borderColor,
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: resumenLabelW, fillColor: lightBg, textColor: labelColor, fontStyle: "bold" },
        1: { cellWidth: resumenW - resumenLabelW, halign: "right" },
      },
      didParseCell: (h) => {
        if (h.row.index === bodyTotales.length - 1) {
          h.cell.styles.fillColor = brandColor;
          h.cell.styles.textColor = [255, 255, 255];
          h.cell.styles.fontStyle = "bold";
          h.cell.styles.fontSize = 10.5;
        }
      },
    });

    currentY = doc.autoTable.previous.finalY + 8;

    // ============ TOTALES X COLABORADORES — mini-tabla similar ============
    if (colaboradores > 1) {
      const piezasXC = totalPiezasGlobal * colaboradores;
      const subtotalXC = +(subtotalGlobal * colaboradores).toFixed(2);
      const descuentoXC = +(descuentoDinero * colaboradores).toFixed(2);
      const baseIVAXC = +(baseIVA * colaboradores).toFixed(2);
      const ivaXC = +(ivaGlobal * colaboradores).toFixed(2);
      const totalConIvaXC = +(totalConIva * colaboradores).toFixed(2);

      if (currentY + 50 > pageHeight - marginBottom) {
        doc.addPage();
        currentY = 20;
      }

      doc.setFont(undefined, "bold");
      doc.setFontSize(11);
      doc.setTextColor(...brandColor);
      doc.text(
        `TOTAL X COLABORADORES (${fmtInt(colaboradores)})`,
        pageWidth - marginRight,
        currentY,
        { align: "right" }
      );
      doc.setTextColor(0);
      currentY += 3;

      const bodyTotalesColab = [
        ["Total de piezas x colab.", fmtInt(piezasXC)],
        ["Subtotal x colab.", fmtMoney(subtotalXC)],
      ];

      if (descuentoPorcentaje > 0) {
        bodyTotalesColab.push([
          `Descuento (${descuentoPorcentaje}%) x colab.`,
          `- ${fmtMoney(descuentoXC)}`,
        ]);
        bodyTotalesColab.push([
          "Subtotal con descuento x colab.",
          fmtMoney(baseIVAXC),
        ]);
      }

      bodyTotalesColab.push(["IVA (16%) x colab.", fmtMoney(ivaXC)]);
      bodyTotalesColab.push(["Total con IVA x colab.", fmtMoney(totalConIvaXC)]);

      doc.autoTable({
        startY: currentY,
        margin: { left: resumenX, right: marginRight },
        tableWidth: resumenW,
        body: bodyTotalesColab,
        theme: "grid",
        styles: {
          fontSize: 9.5,
          cellPadding: 1.4,
          lineColor: borderColor,
          lineWidth: 0.2,
        },
        columnStyles: {
          0: { cellWidth: resumenLabelW, fillColor: lightBg, textColor: labelColor, fontStyle: "bold" },
          1: { cellWidth: resumenW - resumenLabelW, halign: "right" },
        },
        didParseCell: (h) => {
          if (h.row.index === bodyTotalesColab.length - 1) {
            h.cell.styles.fillColor = brandColor;
            h.cell.styles.textColor = [255, 255, 255];
            h.cell.styles.fontStyle = "bold";
            h.cell.styles.fontSize = 10.5;
          }
        },
      });

      currentY = doc.autoTable.previous.finalY + 8;
    }

    // ============ CONDICIONES — caja con label band ============
    const condicionesSan = s(condiciones).trim().replace(/\t/g, "  ").replace(/\r/g, "");
    if (condicionesSan) {
      if (currentY + 30 > pageHeight - marginBottom) {
        doc.addPage();
        currentY = 20;
      }
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, cardW, 6, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.text(`CONDICIONES DE LA COTIZACIÓN #${s(numero)}`, marginLeft + 3, currentY + 4.2);
      doc.setTextColor(0);
      currentY += 6;

      doc.setFont(undefined, "normal");
      doc.setFontSize(9);
      const lines = doc.splitTextToSize(condicionesSan, cardW - 10);
      const blockH = lines.length * 4.2;

      if (currentY + blockH + 6 > pageHeight - marginBottom) {
        doc.addPage();
        currentY = 20;
      }
      doc.setFillColor(...lightBg);
      doc.setDrawColor(...borderColor);
      doc.rect(marginLeft, currentY, cardW, blockH + 5, "FD");
      doc.setDrawColor(0);
      doc.text(lines, marginLeft + 3, currentY + 4);
      currentY += blockH + 8;
    }

    // ============ ATENTAMENTE + FIRMA ============
    const signatureBlockHeight = 28;
    if (currentY + signatureBlockHeight > pageHeight - marginBottom) {
      doc.addPage();
      currentY = 20;
    }
    currentY += 8;

    doc.setFont(undefined, "bold");
    doc.setFontSize(10);
    doc.text("ATENTAMENTE", pageWidth / 2, currentY, { align: "center" });
    currentY += 12;

    const sigLineWidth = 70;
    const sigStartX = (pageWidth - sigLineWidth) / 2;
    doc.setDrawColor(0);
    doc.setLineWidth(0.3);
    doc.line(sigStartX, currentY, sigStartX + sigLineWidth, currentY);
    currentY += 5;

    doc.setFont(undefined, "bold");
    doc.setFontSize(10);
    doc.text(s(nombreFirma), pageWidth / 2, currentY, { align: "center" });
    currentY += 5;
    doc.setFont(undefined, "normal");
    doc.setFontSize(9);
    doc.text(s(puestoFirma), pageWidth / 2, currentY, { align: "center" });

    // ============ FOOTER paginado en cada página ============
    try {
      const pageCount = doc.internal.getNumberOfPages();
      for (let p = 1; p <= pageCount; p++) {
        doc.setPage(p);
        doc.setFontSize(8);
        doc.setTextColor(...labelColor);
        doc.text(
          `Cotización #${s(numero)}  ·  ${s(clientes)}  ·  Página ${p} de ${pageCount}`,
          pageWidth / 2,
          pageHeight - 5,
          { align: "center" }
        );
        doc.setTextColor(0);
      }
    } catch (errFooter) {
      console.warn("No se pudo dibujar footer:", errFooter);
    }

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDFOC:", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
}


  function editCotizaciones(event) {
    event.preventDefault();
    const URL_COTIZACIONES_EDIT = `${process.env.REACT_APP_URL_COTIZACIONES}/${idEdit}`;
    if (file == null) {
      axios
        .patch(
          URL_COTIZACIONES_EDIT,
          {
            fecha,
            colaboradores: selectedColaboradorEdit,
            // (2026-10) las de prospecto no traen cliente hasta que se elija uno
            ...(selectedClienteEdit ? { clientes: selectedClienteEdit } : {}),
            empresas: selectedEmpresaEdit,
            compradores: selectedCompradorEdit,
            // total_general,
            observaciones: observacionesEdit,
            condiciones: condicionesEdit,
            nombreFirma: nombreFirmaEdit,
            puestoFirma: puestoFirmaEdit,
            nombreComprador: nombreCompradorEdit,
            puestoComprador: puestoCompradorEdit,
            cantidadColaboradores: cantidadColaboradoresEdit,
            cotizacionCliente,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
            .then(() => {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Editar Cotizacion",
                  detalle: `${numero_cotizacion} ${fecha}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );

              toggleEdit();
              Swal.fire("Good job!", "Actualizado con exito", "success");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
    } else {
      axios
        .patch(
          URL_COTIZACIONES_EDIT,
          {
            fecha,
            colaboradores: selectedColaboradorEdit,
            // (2026-10) las de prospecto no traen cliente hasta que se elija uno
            ...(selectedClienteEdit ? { clientes: selectedClienteEdit } : {}),
            empresas: selectedEmpresaEdit,
            compradores: selectedCompradorEdit,
            // total_general,
            observaciones: observacionesEdit,
            condiciones: condicionesEdit,
            nombreFirma: nombreFirmaEdit,
            puestoFirma: puestoFirmaEdit,
            nombreComprador: nombreCompradorEdit,
            puestoComprador: puestoCompradorEdit,
            cantidadColaboradores: cantidadColaboradoresEdit,
            cotizacionCliente,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("articulo", idArticuloEdit);

          axios
            .post(URL_FILEPOST, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
                .then(() => {
                  axios.post(
                    URL_LOGS,
                    {
                      tipo: "Editar Cotizacion",
                      detalle: `${numero_cotizacion} ${fecha}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  );

                  toggleEdit();
                  Swal.fire("Good job!", "Actualizado con exito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log(error);
        });
    }
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "Empresa", field: "empresas", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Comprador", field: "nombreComprador", sortable: true },
    { name: "Vendedor", field: "colaboradores", sortable: false },
    { name: "Cant Colab", field: "cantidadColaboradores", sortable: false },
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Autorizada", field: "autorizacion", sortable: true },
    { name: "Info", field: "info", sortable: false },
    { name: "Editar", field: "editar", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.empresas.toLowerCase().includes(search.toLowerCase()) ||
          comment.nombreComprador.toLowerCase().includes(search.toLowerCase()) ||
          comment.colaboradores.toLowerCase().includes(search.toLowerCase()) ||
          comment.fecha.toLowerCase().includes(search.toLowerCase()) ||
          comment.cantidad.toString().includes(search) ||
          comment.cantidadColaboradores.toString().includes(search) ||
          comment.total_general.toString().includes(search) ||
          comment.numero.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedEmpresa) {
      computedComments = computedComments.filter((e) =>
        e.idEmpresas.includes(selectedEmpresa)
      );
    }
    if (selectedComprador) {
      computedComments = computedComments.filter((e) =>
        e.idCompradores.includes(selectedComprador)
      );
    }
    // if (selectedMarca) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idMarcas.includes(selectedMarca)
    //   );
    // }
    if (selectedColaborador) {
      computedComments = computedComments.filter((e) =>
        e.idColaboradores.includes(selectedColaborador)
      );
    }

    if (selectedArticulo) {
      computedComments = computedComments.filter((e) =>
        e.idArticulo.includes(selectedArticulo)
      );
    }
    if (selectedStatus) {
      computedComments = computedComments.filter((e) =>
        e.status.includes(selectedStatus)
      );
    }
    if (selectedPendFechaConf) {
      computedComments = computedComments.filter((e) =>
        e.pendFechaConf.includes(selectedPendFechaConf)
      );
    }
    // if (activo) {
    //   computedComments = computedComments.filter((e) =>
    //     e.activo.includes(activo)
    //   );
    // }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidad" &&
      sorting.field != "cantidadColaboradores" &&
      sorting.field != "total_general" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "cantidadColaboradores" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "cantidadColaboradores" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedEmpresa,
    selectedComprador,
    // selectedMarca,
    selectedColaborador,
    selectedArticulo,
    // activo,
    selectedFechaInicio,
    selectedFechaFin,
    selectedStatus,
    selectedPendFechaConf,
  ]);

async function EditArticulos(idOC, numero_cotizacion, idCliente) {
  setInputFields([]);
  setIdEdit(idOC);
  setNumeroCotizacion(numero_cotizacion);
  if (idCliente) setSelectedClienteEdit(idCliente);

  // T5 (2026-06) — cargar descuento general actual de la cotización
  try {
    const cotRes = await axios.get(
      `${process.env.REACT_APP_URL_COTIZACIONES}/${idOC}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );
    setDescuentoEdit(Number(cotRes.data?.descuento) || 0);
  } catch (e) {
    console.warn("No se pudo cargar el descuento:", e);
    setDescuentoEdit(0);
  }

  try {
    const res = await axios.get(`${URL_ARTICULOS_COTIZACION}/cotizaciones/${idOC}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    });

    const data = res.data;
    const agrupado = {};

    data.forEach((a) => {
      const area = a.areasClientes?.[0]?.name || "Sin Área";
      const articulo = a.articulos?.[0]?.nombre || a.articulos?.[0]?.descripcion || "Sin Artículo";

      if (!agrupado[area]) agrupado[area] = [];

      agrupado[area].push({
        id: a._id,
        tela: a.tela || "",
        cantidad: parseFloat(a.cantidad) || 0,
        precio: parseFloat(a.precio) || 0,
        total: parseFloat(a.total) || 0,
        orden: Number(a.orden) || 0, // L120 — consecutivo de impresión editable
        areasClientes: a.areasClientes?.[0]?._id || "",
        articuloId: a.subDepartamentos?.[0]?._id || "",
        articuloNombre: a.subDepartamentos?.[0]?.name || "Sin Artículo",
        subDepartamentos: a.subDepartamentos?.[0]?._id || "",
        departamentos: a.departamentos?.[0]?._id || "",
        observacionesArticulo: a.observacionesArticulo || "NA",
      });
    });

    // L120 — ordenar por el consecutivo `orden` (los que tengan 0/ausente al final
    // por nombre), para que el modal muestre y permita editar el orden de impresión
    Object.keys(agrupado).forEach((area) => {
      agrupado[area].sort((a, b) => {
        const oa = Number(a.orden) > 0 ? Number(a.orden) : Infinity;
        const ob = Number(b.orden) > 0 ? Number(b.orden) : Infinity;
        if (oa !== ob) return oa - ob;
        return a.articuloNombre.localeCompare(b.articuloNombre);
      });
    });

    setInputFields(agrupado);

    const totalCant = data.reduce((sum, item) => sum + parseFloat(item.cantidad || 0), 0);
    const totalGen = data.reduce((sum, item) => sum + parseFloat(item.total || 0), 0);
    setTotalCantidadEdit(totalCant);
    setTotalGeneralEdit(totalGen);
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "No se pudo cargar la cotización", "error");
  }

  toggleEditArticulos();
}


function handleGroupedInputChange(clave, idx, campo, valor) {
  // T9 (2026-06) — cada renglón es independiente. Antes propagaba cambios de
  // precio/tela a TODAS las filas con el mismo articuloId, ahora solo la fila
  // editada en [clave][idx] cambia.
  setInputFields((prev) => {
    const nuevo = { ...prev };
    const lista = Array.isArray(nuevo[clave]) ? [...nuevo[clave]] : [];
    const filaActual = { ...lista[idx], [campo]: valor };

    const cantidad = parseFloat(filaActual.cantidad) || 0;
    const precio = parseFloat(filaActual.precio) || 0;
    filaActual.total = parseFloat((cantidad * precio).toFixed(2));

    lista[idx] = filaActual;
    nuevo[clave] = lista;

    // Recalcular totales globales
    const flat = Object.values(nuevo).flat();
    const nuevaCantidad = flat.reduce(
      (acc, f) => acc + (parseFloat(f.cantidad) || 0),
      0
    );
    const nuevoTotal = flat.reduce(
      (acc, f) => acc + (parseFloat(f.total) || 0),
      0
    );

    setTotalCantidadEdit(nuevaCantidad);
    setTotalGeneralEdit(parseFloat(nuevoTotal.toFixed(2)));

    return nuevo;
  });
}


function handleGroupedInputChangeTela(clave, idx, valor) {
  setInputFields((prev) => {
    const nuevo = { ...prev };
    const fila = { ...nuevo[clave][idx], tela: valor };
    nuevo[clave][idx] = fila;
    return nuevo;
  });
}

function handleGroupedInputChangeObservaciones(clave, idx, valor) {
  setInputFields((prev) => {
    const nuevo = { ...prev };
    const fila = {
      ...nuevo[clave][idx],
      observacionesArticulo: valor ?? "",
    };
    nuevo[clave][idx] = fila;
    return nuevo;
  });
}

function handleNewItemField(clave, idx, campo, valor) {
  setInputFields((prev) => {
    const nuevo = { ...prev };
    const lista = Array.isArray(nuevo[clave]) ? [...nuevo[clave]] : [];
    if (!lista[idx]) return prev;
    lista[idx] = { ...lista[idx], [campo]: valor };
    nuevo[clave] = lista;
    return nuevo;
  });
}

function handleAddArticuloEdit(clave, areaId) {
  setInputFields((prev) => {
    const nuevo = { ...prev };
    const lista = Array.isArray(nuevo[clave]) ? [...nuevo[clave]] : [];
    lista.push({
      id: `new-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      isNew: true,
      areasClientes: areaId || "",
      articuloId: "",
      articuloNombre: "",
      subDepartamentos: "",
      departamentos: "",
      tela: "",
      cantidad: 0,
      precio: 0,
      total: 0,
      observacionesArticulo: "NA",
    });
    nuevo[clave] = lista;
    return nuevo;
  });
}

function handleRemoveNewArticulo(clave, idx) {
  setInputFields((prev) => {
    const nuevo = { ...prev };
    const lista = Array.isArray(nuevo[clave]) ? [...nuevo[clave]] : [];
    lista.splice(idx, 1);
    nuevo[clave] = lista;

    const flat = Object.values(nuevo).flat();
    const nuevaCantidad = flat.reduce(
      (acc, f) => acc + (parseFloat(f.cantidad) || 0),
      0
    );
    const nuevoTotal = flat.reduce(
      (acc, f) => acc + (parseFloat(f.total) || 0),
      0
    );
    setTotalCantidadEdit(nuevaCantidad);
    setTotalGeneralEdit(parseFloat(nuevoTotal.toFixed(2)));

    return nuevo;
  });
}

function handleNewArticuloSelect(clave, idx, subDepartamentoId) {
  const sub = subDepartamentosCat.find((s) => s._id === subDepartamentoId);
  setInputFields((prev) => {
    const nuevo = { ...prev };
    const lista = Array.isArray(nuevo[clave]) ? [...nuevo[clave]] : [];
    const fila = { ...lista[idx] };
    fila.subDepartamentos = subDepartamentoId;
    fila.articuloNombre = sub?.name || "";
    fila.articuloId = subDepartamentoId;
    if (!fila.departamentos) {
      const hermano = lista.find(
        (it) => it && it.departamentos && it.id !== fila.id
      );
      fila.departamentos = hermano?.departamentos || "";
    }
    lista[idx] = fila;
    nuevo[clave] = lista;
    return nuevo;
  });
}

  function ActualizaTotales() {
    let cantidadExistentes = articulosCotizacion.map((c) => parseFloat(c.cantidad));
    let cantidadNuevos = inputFields.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosCotizacion.map((c) => parseFloat(c.total));
    let importesNuevos = inputFields.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  }

const saveCotizacion = async (event) => {
  event.preventDefault();
  setValidaBoton(false);
  toggleProgreso();

  const URL_COTIZACIONES_EDIT = `${process.env.REACT_APP_URL_COTIZACIONES}/${idEdit}`;
  const articulosFlat = Object.values(inputFields).flat();
  let totalOperaciones = articulosFlat.length;

  try {
    await axios.patch(
      URL_COTIZACIONES_EDIT,
      {
        total_piezas: total_cantidad_edit,
        total_general: total_general_edit,
        // T5 (2026-06) — descuento editable
        descuento: Number(descuento_edit) || 0,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    for (const a of articulosFlat) {
      if (a.isNew) {
        if (!a.subDepartamentos || !a.departamentos || !a.articuloNombre) {
          totalOperaciones--;
          continue;
        }
        await axios.post(
          URL_ARTICULOS_COTIZACION,
          {
            cotizaciones: idEdit,
            departamentos: a.departamentos,
            subDepartamentos: a.subDepartamentos,
            articuloNombre: a.articuloNombre,
            tela: a.tela || "NA",
            cantidad: parseFloat(a.cantidad) || 0,
            descuento: 0,
            precio: parseFloat(a.precio) || 0,
            total: parseFloat(a.total) || 0,
            orden: parseInt(a.orden) || 0, // L120
            sociedades: "6775c905d688145c579d8393",
            areasClientes: a.areasClientes,
            observacionesArticulo: a.observacionesArticulo || "NA",
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
      } else {
        await axios.patch(
          `${URL_ARTICULOS_COTIZACION}/${a.id}`,
          {
            cantidad: parseFloat(a.cantidad),
            precio: parseFloat(a.precio),
            total: parseFloat(a.total),
            orden: parseInt(a.orden) || 0, // L120
            tela: a.tela,
            articuloNombre: a.articuloNombre,
            observacionesArticulo: a.observacionesArticulo || "NA",
            ...(a.subDepartamentos
              ? { subDepartamentos: a.subDepartamentos }
              : {}),
            ...(a.areasClientes
              ? { areasClientes: a.areasClientes }
              : {}),
            ...(a.departamentos
              ? { departamentos: a.departamentos }
              : {}),
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
      }
      totalOperaciones--;
    }

    if (totalOperaciones === 0) {
      await axios.post(
        URL_LOGS,
        {
          tipo: "Editar Cotizacion",
          detalle: `${numero_cotizacion}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      Swal.fire("¡Éxito!", "Cotizacion editado correctamente", "success");
      setTimeout(() => window.location.reload(), 1000);
    }
  } catch (error) {
    console.log(error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudo guardar el cotizacion",
      footer: error?.response?.data || "",
    });
  }
};

  // (2026-09) Autorización de la cotización: se marca / desmarca desde el
  // listado y queda registrado quién la autorizó y cuándo.
  const estaAutorizada = (a) => String(a?.autorizacion || "No") === "Si";

  async function toggleAutorizacion(a) {
    const autorizar = !estaAutorizada(a);

    const res = await Swal.fire({
      title: autorizar ? "¿Autorizar la cotización?" : "¿Quitar la autorización?",
      text: autorizar
        ? "Se marcará como autorizada."
        : "Se marcará como no autorizada.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: autorizar ? "Si, autorizar" : "Si, quitar",
      cancelButtonText: "Cancelar",
    });
    if (!res.isConfirmed) return;

    try {
      await axios.patch(
        `${URL_COTIZACIONES}/${a._id}`,
        {
          autorizacion: autorizar ? "Si" : "No",
          // autorizacionUser es ObjectId: al quitarla va null ("" truena con
          // CastError en Mongoose).
          ...(autorizar
            ? {
                autorizacionUser: user.id,
                autorizacionFecha: moment().format("YYYY-MM-DD"),
              }
            : { autorizacionUser: null, autorizacionFecha: "" }),
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      setComments((prev) =>
        (prev || []).map((i) =>
          i._id === a._id
            ? {
                ...i,
                autorizacion: autorizar ? "Si" : "No",
                autorizacionUser: autorizar
                  ? `${user.nombre || ""} ${user.apellido || ""}`.trim()
                  : "",
                autorizacionFecha: autorizar
                  ? moment().format("YYYY-MM-DD")
                  : "",
              }
            : i
        )
      );

      Swal.fire({
        position: "center",
        icon: "success",
        title: autorizar ? "Cotización autorizada" : "Autorización retirada",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      const d = error?.response?.data;
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo actualizar la autorización",
        footer:
          typeof d === "string" ? d : d?.message || JSON.stringify(d || {}),
      });
      console.log(error);
    }
  }

  function abierto(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se Abrirá!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Abrir!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_COTIZACIONES}/${id}`,
            {
              status: "Abierto",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                `${URL_ARTICULOS_COTIZACION}/baja/${id}`,
                {
                  is_active: "Si",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                const newComments = comments.map((i) => {
                  if (id === i._id) {
                    i.status = "Abierto";
                  }
                  return i;
                });
                setComments(newComments);

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se Abrió",
                  showConfirmButton: false,
                  timer: 2000,
                });
                // setTimeout(() => {
                //   // window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function cerrar(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se Cerrará!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cerrar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_COTIZACIONES}/${id}`,
            {
              status: "Cerrado",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                `${URL_ARTICULOS_COTIZACION}/baja/${id}`,
                {
                  is_active: "No",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                const newComments = comments.map((i) => {
                  if (id === i._id) {
                    i.status = "Cerrado";
                  }
                  return i;
                });
                setComments(newComments);

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se Cerró",
                  showConfirmButton: false,
                  timer: 2000,
                });

                // setTimeout(() => {
                //   // window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function ordenCorteSi(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se Cerrará!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cerrar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_COTIZACIONES}/${id}`,
            {
              ordenCorte: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se Cerró",
                  showConfirmButton: false,
                  timer: 2000,
                });

                // setTimeout(() => {
                //   // window.location.reload();
                // }, 1000);

          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function ordenCorteNo(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se Cerrará!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cerrar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_COTIZACIONES}/${id}`,
            {
              ordenCorte: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se Cerró",
                  showConfirmButton: false,
                  timer: 2000,
                });

                // setTimeout(() => {
                //   // window.location.reload();
                // }, 1000);

          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function editArticulos(event) {
    event.preventDefault();
    const URL_ARTICULOS_EDIT = `${process.env.REACT_APP_URL_ARTICULOS}/${idEditArticuloEdit}`;
    axios
      .patch(
        URL_ARTICULOS_EDIT,
        {
          codigo: codigoEdit,
          codigoCliente: codigoClienteEdit,
          descripcion: descripcionEdit,
          venta: ventaEdit,
          precioEtiqueta: precioEtiquetaEdit,
          observaciones: observacionesEdit,
          observacionesProduccion: observacionesProduccionEdit,
          // marcas: selectedMarcaEdit,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Articulo",
            detalle: `${codigo}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_pedidos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.pedidos_create ? (
                <>
                  {/* <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    href="/ArticulosCreate"
                  >
                    Nueva Cotizacion
                  </Button> */}

                  <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    href="/CotizacionesCreate"
                  >
                    {/* Cotizacion Resurtido */}
                    Nueva Cotizacion
                  </Button>
                </>
              ) : (
                <>
                  {/* <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    disabled
                  >
                    Nueva Cotizacion
                  </Button> */}

                  <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    disabled
                  >
                    {/* Cotizacion Resurtido */}
                    Nueva Cotizacion
                  </Button>
                </>
              )}
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                {/* <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={desarrollo}
                >
                  Desarrollo
                </Button> */}
                {user.cot_pdf && (
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                )}
                {user.cot_email && (
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                )}
                {user.cot_excel && (
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                )}
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Cotizaciones</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Cotizaciones</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td></td>
              {/* L15 (2026-06) — filtro por Empresa */}
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedEmpresa}
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => (
                      <option key={a._id} value={a._id}>{a.name}</option>
                    ))}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCliente}
                  onChange={(e) => {
                    setSelectedCliente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
              {/* (filtro empresa antiguo - movido arriba) */}
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedComprador}
                  onChange={(e) => {
                    setSelectedComprador(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {compradores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td> */}
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedColaborador}
                  onChange={(e) => {
                    setSelectedColaborador(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {colaboradores
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return (
                        <option value={a._id}>
                          {a.nombre} {a.apellido}
                        </option>
                      );
                    })}
                </Input>
              </td>
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArticulo}
                  onChange={(e) => {
                    setSelectedArticulo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {articulos
                    .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                    .map((a) => {
                      return (
                        <option value={a._id}>
                          {a.codigo} {a.codigoCliente} {a.descripcion}
                        </option>
                      );
                    })}
                </Input>
              </td> */}
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedMarca}
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {marcas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td> */}
              {/* <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedPendFechaConf}
                  onChange={(e) => {
                    setSelectedPendFechaConf(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </td> */}
              {/* <td></td>
              <td></td>
              <td></td> */}
              <td></td>
              <td></td>
              <td></td>
              {/* (2026-09) columna Autorizada */}
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedStatus}
                  required
                  onChange={(e) => {
                    setSelectedStatus(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Abierto">Abierto</option>
                  <option value="Pedido">Pedido</option>
                  <option value="Cerrado">Cerrado</option>
                </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                return (
                  // <tr style={ a.activo == "Si" ? { backgroundColor: "#ffff00" } : undefined}>
                  <tr> 
                    <td>{a.numero}</td>
                    <td>{a.fecha}</td>
                    <td>{a.empresas}</td>
                    <td>{a.clientes}</td>
                    <td>{a.nombreComprador}</td>
                    <td>{a.colaboradores}</td>
                    <td>{new Intl.NumberFormat("en-US").format(a.cantidadColaboradores)}</td>
                    <td>{new Intl.NumberFormat("en-US").format(a.cantidad)}</td>
                    <td>
                      {/* T5 (2026-06) — total CON descuento aplicado */}
                      {(() => {
                        const sub = Number(a.total_general) || 0;
                        const desc = Number(a.descuento) || 0;
                        const finalTotal = +(sub - sub * (desc / 100)).toFixed(2);
                        return (
                          <span>
                            {"$" + new Intl.NumberFormat("en-US").format(finalTotal)}
                            {desc > 0 && (
                              <div style={{ fontSize: "10px", color: "#6b7280" }}>
                                Subtotal $
                                {new Intl.NumberFormat("en-US").format(sub)} · -{desc}%
                              </div>
                            )}
                          </span>
                        );
                      })()}
                    </td>
                    <td>
                      {estaAutorizada(a) ? (
                        <>
                          <span className="badge bg-success">Autorizada</span>
                          {(a.autorizacionUser || a.autorizacionFecha) && (
                            <div style={{ fontSize: "10px", color: "#6b7280" }}>
                              {a.autorizacionUser}
                              {a.autorizacionUser && a.autorizacionFecha
                                ? " · "
                                : ""}
                              {a.autorizacionFecha}
                            </div>
                          )}
                        </>
                      ) : (
                        <span className="badge bg-secondary">No</span>
                      )}
                    </td>
                    <td>

                          {/* <Button
                            color="danger"
                            id="Editar"
                            size="sm"
                            onClick={(e) =>
                              requisicionGlobal(a._id, a.idArticulo, a.numero)
                            }
                          >
                            <i class="fas fa-tape"></i>
                          </Button>
                          <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) => requisicion(a._id, a.numero)}
                          >
                            <i class="fas fa-tag"></i>
                          </Button> */}

                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            title="PDF de la cotización"
                            onClick={(e) =>
                              PDFOC(
                                a.fecha,
                                a.clientes,
                                a.condiciones,
                                a.nombreFirma,
                                a.puestoFirma,
                                a.nombreComprador,
                                a.puestoComprador,
                                a.cantidadColaboradores,
                                a.numero,
                                a._id,
                                a.calle,
                                a.colonia,
                                a.ciudad,
                                a.telefono,
                                a.email,
                                a.descuento,
                                a.empresas // L105
                              )
                            }
                          >
                            <i class="far fa-file-pdf"></i>
                          </Button>

                          {/* (2026-09) Autorizar / quitar autorización */}
                          <Button
                            size="sm"
                            className="btn"
                            color={estaAutorizada(a) ? "success" : "warning"}
                            title={
                              estaAutorizada(a)
                                ? `Autorizada${
                                    a.autorizacionUser
                                      ? ` por ${a.autorizacionUser} ${a.autorizacionFecha}`
                                      : ""
                                  } — clic para quitar la autorización`
                                : "Marcar la cotización como autorizada"
                            }
                            onClick={(e) => toggleAutorizacion(a)}
                          >
                            <i
                              className={
                                estaAutorizada(a)
                                  ? "fas fa-check-circle"
                                  : "fas fa-stamp"
                              }
                            ></i>{" "}
                            {/*{estaAutorizada(a) ? "Autorizada" : "Autorizar"}*/}
                          </Button>

                          {/* <BajaMultiple
                              idStatus={a._id}
                              is_active={a.activo}
                              URL_BAJA={process.env.REACT_APP_URL_COTIZACIONES}
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_COTIZACION}/baja`}
                            /> */}
                          {/* <StatusMultiple
                              idStatus={a._id}
                              status={a.status}
                              URL_STATUS={process.env.REACT_APP_URL_COTIZACIONES}
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_COTIZACION}/baja`}
                            /> */}
                        
                     
                    </td>
                    <td>
                      {a.status == "Abierto" && a.activo == "Si" ? (
                        <div>
                          <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) =>
                              jalaInfo(
                                a.fecha,
                                a.idColaboradores,
                                a.idClientes,
                                a.idEmpresas,
                                a.idCompradores,
                                a.observaciones,
                                a.condiciones,
                                a.nombreFirma,
                                a.puestoFirma,
                                a.nombreComprador,
                                a.puestoComprador,
                                a.cantidadColaboradores,
                                a.numero,
                                a._id,
                                a.cotizacionCliente
                              )
                            }
                          >
                            <i class="far fa-edit"></i>
                          </Button>
                          <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) =>
                              EditArticulos(a._id, a.numero, a.idClientes)
                            }
                          >
                            <i class="fas fa-cart-plus"></i>
                          </Button>
                          {/* {a.fotoArticulo == "No" ? (
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              // onClick={(e) => jalaFoto(a.idArticulo)}
                              disabled
                            >
                              <i class="fas fa-camera"></i>
                            </Button>
                          ) : (
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => jalaFoto(a.idArticulo)}
                            >
                              <i class="fas fa-camera"></i>
                            </Button>
                          )} */}
                          <Button
                            color="primary"
                            id="Cerrar"
                            onClick={(e) => cerrar(a._id)}
                            size="sm"
                          >
                            <i class="fas fa-lock-open"></i>
                          </Button>
                          {/* {a.ordenCorte == "No" ? (
                            <Button
                            color="danger"
                            id="Cerrar"
                            onClick={(e) => ordenCorteSi(a._id)}
                            size="sm"
                          >
                            <i class="fas fa-cut"></i>
                          </Button> ) : (
                            <Button
                            color="primary"
                            id="Cerrar"
                            onClick={(e) => ordenCorteNo(a._id)}
                            size="sm"
                          >
                            <i class="fas fa-cut"></i>
                          </Button>
                          
                          )} */}
                          
                        </div>
                      ) : (
                        <div>
                          <Button color="info" id="Editar" size="sm" disabled>
                            <i class="far fa-edit"></i>
                          </Button>
                          <Button color="info" id="Editar" size="sm" disabled>
                            <i class="fas fa-cart-plus"></i>
                          </Button>
                          <Button
                            color="danger"
                            onClick={(e) => abierto(a._id)}
                            size="sm"
                          >
                            <i class="fas fa-lock"></i>
                          </Button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar Cotizacion {numero_cotizacion}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={4}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                onChange={(e) => {
                  setFecha(e.target.value);
                }}
              />
            </Col>
            {/* L15 (2026-06) — Empresa editable */}
            <Col md={4}>
              <Label className="mr-sm-2">Empresa</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedEmpresaEdit}
                required
                onChange={(e) => {
                  setSelectedEmpresaEdit(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {empresas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => (
                    <option key={a._id} value={a._id}>{a.name}</option>
                  ))}
              </Input>
            </Col>
            <Col md={4}>
              <Label className="mr-sm-2">Cliente</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedClienteEdit}
                required
                onChange={(e) => {
                  setSelectedClienteEdit(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            {/* <Col md={4}>
              <Label className="mr-sm-2">Comprador</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedCompradorEdit}
                required
                onChange={(e) => {
                  setSelectedCompradorEdit(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {compradores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col> */}
          </Row>
          <Row>
            <Col md={4}>
              <Label>Vendedor</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedColaboradorEdit}
                required
                onChange={(e) => {
                  setSelectedColaboradorEdit(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>
            <Col md={4}>
              <Label for="exampleEmail" className="mr-sm-2">
                Nombre Firma
              </Label>
              <Input
                type="text"
                placeholder="NombreFirma"
                value={nombreFirmaEdit}
                required
                onChange={(e) => {
                  setNombreFirmaEdit(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label for="exampleEmail" className="mr-sm-2">
                Puesto Firma
              </Label>
              <Input
                type="text"
                placeholder="PuestoFirma"
                value={puestoFirmaEdit}
                required
                onChange={(e) => {
                  setPuestoFirmaEdit(e.target.value);
                }}
              />
            </Col>
            {/* <Col md={4}>
              <Label className="mr-sm-2">Empresa</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedEmpresaEdit}
                required
                onChange={(e) => {
                  setSelectedEmpresaEdit(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {empresas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col> */}

            {/* <Col md={4}>
              <Label className="mr-sm-2">Cotizacion Cliente</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={cotizacionCliente}
                required
                onChange={(e) => {
                  setCotizacionCliente(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {empresas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col> */}
          </Row>
          {/* <Row>
            <Col md={4}>
              <Label>Fecha Cancelacion</Label>
              <Input
                type="date"
                placeholder="Fecha Cancelacion"
                value={fecha_cancelacion}
                required
                onChange={(e) => {
                  setFechaCancelacion(e.target.value);
                  let inicio = new Date(e.target.value);
                  let bla = inicio.setDate(inicio.getDate() - 41);
                  setFechaConfirmacion(moment(bla).format("YYYY-MM-DD"));
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Fecha Confirmacion</Label>
              <Input
                type="date"
                placeholder="Fecha Confirmacion"
                value={fecha_confirmacion}
                required
                onChange={(e) => {
                  setFechaConfirmacion(e.target.value);
                }}
              />
            </Col>
          </Row> */}
          <Row>
             <Col md={4}>
              <Label for="exampleEmail" className="mr-sm-2">
                Nombre Comprador
              </Label>
              <Input
                type="text"
                placeholder="NombreComprador"
                value={nombreCompradorEdit}
                required
                onChange={(e) => {
                  setNombreCompradorEdit(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label for="exampleEmail" className="mr-sm-2">
                Puesto Comprador
              </Label>
              <Input
                type="text"
                placeholder="PuestoComprador"
                value={puestoCompradorEdit}
                required
                onChange={(e) => {
                  setPuestoCompradorEdit(e.target.value);
                }}
              />
            </Col>

             <Col md={4}>
              <Label for="exampleEmail" className="mr-sm-2">
                Cantidad Colaboradores
              </Label>
              <Input
                type="text"
                placeholder="CantidadColaboradores"
                value={cantidadColaboradoresEdit}
                required
                onChange={(e) => {
                  setCantidadColaboradoresEdit(e.target.value);
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observacionesEdit}
                rows={3}
                onChange={(e) => {
                  setObservacionesEdit(e.target.value || "NA");
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Label for="exampleEmail" className="mr-sm-2">
                Condiciones
              </Label>
              <Input
                type="textarea"
                placeholder="Condiciones"
                value={condicionesEdit}
                required
                onChange={(e) => {
                  setCondicionesEdit(e.target.value);
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editCotizaciones}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>



<Modal size="xxl" isOpen={modalEditArticulos} toggle={toggleEditArticulos}>
  <ModalHeader toggle={toggleEditArticulos}>
    <h4>Editar Artículos Cotizacion {numero_cotizacion}</h4>
    <h4>
      TOTALES {new Intl.NumberFormat("en-US").format(total_cantidad_edit)} pzas. /
      {" $" + new Intl.NumberFormat("en-US").format(total_general_edit)}
    </h4>
  </ModalHeader>
  <ModalBody>
    <Form onSubmit={saveCotizacion}>
      {Object.entries(inputFields).map(([clave, items]) => {
        const [area] = clave.split("||");
        const areaId =
          (Array.isArray(items) && items.find((x) => x.areasClientes)?.areasClientes) ||
          "";
        return (
          <div key={clave} style={{ marginBottom: "2rem" }}>
            <h5 style={{ marginBottom: "1rem" }}>Area: {area}</h5>
            <Row className="fw-bold text-center mb-2">
              <Col md={1}>Area</Col>
              <Col md={1}>Depto</Col>
              <Col md={2}>Articulo</Col>
              <Col md={2}>Tela</Col>
              <Col md={1}>Cant.</Col>
              <Col md={1}>Precio</Col>
              <Col md={1}>Total</Col>
              <Col md={2}>Obs.</Col>
              <Col md={1}>Orden</Col>
              <Col md={1}></Col>
            </Row>

            {Array.isArray(items) &&
              items.map((item, idx) => (
                <Row
                  key={item.id}
                  className="align-items-center text-center mb-2"
                >
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={item.areasClientes || ""}
                      onChange={(e) =>
                        handleNewItemField(
                          clave,
                          idx,
                          "areasClientes",
                          e.target.value
                        )
                      }
                    >
                      <option value="">Selecciona</option>
                      {(areasClientes || [])
                        .filter(
                          (ar) =>
                            !selectedClienteEdit ||
                            String(
                              ar?.clientes?.[0]?._id || ar?.clientes?.[0] || ""
                            ) === String(selectedClienteEdit)
                        )
                        .slice()
                        .sort((a, b) =>
                          (a.name || "") > (b.name || "") ? 1 : -1
                        )
                        .map((ar) => (
                          <option value={ar._id} key={ar._id}>
                            {ar.name}
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={item.departamentos || ""}
                      onChange={(e) =>
                        handleNewItemField(
                          clave,
                          idx,
                          "departamentos",
                          e.target.value
                        )
                      }
                    >
                      <option value="">Selecciona</option>
                      {(departamentosCat || [])
                        .slice()
                        .sort((a, b) =>
                          (a.name || "") > (b.name || "") ? 1 : -1
                        )
                        .map((d) => (
                          <option value={d._id} key={d._id}>
                            {d.name}
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={item.subDepartamentos || ""}
                      onChange={(e) =>
                        handleNewArticuloSelect(clave, idx, e.target.value)
                      }
                    >
                      <option value="">Selecciona</option>
                      {subDepartamentosCat
                        .slice()
                        .sort((a, b) =>
                          (a.name || "") > (b.name || "") ? 1 : -1
                        )
                        .map((a) => (
                          <option value={a._id} key={a._id}>
                            {a.name}
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      type="text"
                      placeholder="Tela"
                      value={item.tela}
                      onChange={(e) =>
                        handleGroupedInputChangeTela(
                          clave,
                          idx,
                          e.target.value
                        )
                      }
                    />
                  </Col>
                  {/* L120 (2026-06) — editar el orden de impresión del artículo en el PDF */}
                  
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      type="number"
                      placeholder="Cant."
                      value={item.cantidad}
                      onChange={(e) =>
                        handleGroupedInputChange(
                          clave,
                          idx,
                          "cantidad",
                          parseFloat(e.target.value) || 0
                        )
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      type="number"
                      placeholder="Precio"
                      value={item.precio}
                      onChange={(e) =>
                        handleGroupedInputChange(
                          clave,
                          idx,
                          "precio",
                          parseFloat(e.target.value) || 0
                        )
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      type="number"
                      placeholder="Total"
                      value={item.total}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      type="text"
                      placeholder="Obs."
                      value={item.observacionesArticulo ?? ""}
                      onChange={(e) =>
                        handleGroupedInputChangeObservaciones(
                          clave,
                          idx,
                          e.target.value
                        )
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      type="number"
                      placeholder="Orden"
                      value={item.orden}
                      onChange={(e) =>
                        handleGroupedInputChange(
                          clave,
                          idx,
                          "orden",
                          parseInt(e.target.value) || 0
                        )
                      }
                    />
                  </Col>
                  <Col md={1}>
                    {item.isNew && (
                      <Button
                        size="sm"
                        color="danger"
                        onClick={() =>
                          handleRemoveNewArticulo(clave, idx)
                        }
                      >
                        <i className="fas fa-minus"></i>
                      </Button>
                    )}
                  </Col>
                </Row>
              ))}
            <Row>
              <Col md={12} className="text-end">
                <Button
                  size="sm"
                  color="info"
                  onClick={() => handleAddArticuloEdit(clave, areaId)}
                >
                  <i className="fas fa-plus"></i> Agregar artículo
                </Button>
              </Col>
            </Row>
          </div>
        );
      })}

      <Row className="mt-4 align-items-center">
        <Col md={5}>
          <h4>
            TOTALES {new Intl.NumberFormat("en-US").format(total_cantidad_edit)} pzas. /
            {" $" + new Intl.NumberFormat("en-US").format(total_general_edit)}
          </h4>
        </Col>
        {/* T5 (2026-06) — descuento general editable */}
        <Col md={3}>
          <Label className="mb-0" style={{ fontSize: "13px", fontWeight: 600 }}>
            Descuento (%)
          </Label>
          <Input
            bsSize="sm"
            type="number"
            min="0"
            max="100"
            step="any"
            value={descuento_edit}
            onChange={(e) => setDescuentoEdit(e.target.value)}
          />
        </Col>
        <Col md={4} className="text-end">
          <Button type="submit" color="success" disabled={!validaBoton}>Guardar</Button>
        </Col>
      </Row>
    </Form>
  </ModalBody>
</Modal>







      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios minutos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>
      <Modal
        size="xl"
        isOpen={modalEditInfoArticulo}
        toggle={toggleEditInfoArticulo}
      >
        <ModalHeader toggle={toggleEditInfoArticulo}>
          <h4>
            Editar Modelo {codigoEdit} / {descripcionEdit}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>Codigo</Label>
              <Input
                type="text"
                placeholder="Codigo"
                value={codigoEdit}
                required
                onChange={(e) => {
                  setCodigoEdit(e.target.value);
                }}
              />
            </Col>

            <Col md={3}>
              <Label>Descripcion</Label>
              <Input
                type="text"
                placeholder="Descripcion"
                value={descripcionEdit}
                required
                onChange={(e) => {
                  setDescripcionEdit(e.target.value);
                }}
              />
            </Col>

            {/* <Col md={3}>
                <Label className="mr-sm-2">Marca</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedMarcaEdit}
                  required
                  onChange={(e) => {
                    setSelectedMarcaEdit(e.target.value);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {marcas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col> */}
          </Row>
          <Row>
            <Col md={3}>
              <Label>CodigoCliente</Label>
              <Input
                type="text"
                placeholder="CodigoCliente"
                value={codigoClienteEdit}
                required
                onChange={(e) => {
                  setCodigoClienteEdit(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row></Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editArticulos}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>
      {loader}
    </>
  );
}

export default ListadoCotizaciones;
